import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Kuumakse

  <span style="color:#85c1dc;">**FI:**</span>
  Kuukausimaksu

  <span style="color:#85c1dc;">**RU:**</span>
  Ежемесячная оплата
*/
/* @__NO_SIDE_EFFECTS__ */
const m1027 = msg(
  mf`Kuumakse`,
  mf`Kuukausimaksu`,
  mf`Ежемесячная оплата`,
)

export { m1027 as 'w.module.product_hero.monthly_pay' }